module.exports = __webpack_public_path__ + "static/media/prev-cal-icon.a25e2819.svg";